import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-primary via-primary-dark to-primary-light text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <img
              src="https://static.readdy.ai/image/602524d9e3f59449eddce061e2bb9ef5/85673504354e4797007d75e7801a20cd.png"
              alt="Kronos Consultoría Contable"
              className="h-16 w-auto mb-6"
            />
            <h3 className="font-heading font-bold text-lg mb-4">Kronos CEO Consultores, S.C.</h3>
            <p className="font-body text-sm text-gray-200 leading-relaxed">
              Consultoría sobresaliente en áreas contable, fiscal, administrativa y automatización de procesos.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-bold text-base mb-6">Navegación</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="font-body text-sm text-gray-200 hover:text-gold transition-colors">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/nosotros" className="font-body text-sm text-gray-200 hover:text-gold transition-colors">
                  Nosotros
                </Link>
              </li>
              <li>
                <Link to="/servicios" className="font-body text-sm text-gray-200 hover:text-gold transition-colors">
                  Servicios
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="font-body text-sm text-gray-200 hover:text-gold transition-colors">
                  Contacto
                </Link>
              </li>
              <li className="pt-2 border-t border-white/20 mt-2">
                <Link to="/superuser" className="font-body text-xs text-gray-400 hover:text-gold transition-colors flex items-center space-x-1">
                  <i className="ri-shield-user-line"></i>
                  <span>Acceso Superusuario</span>
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-base mb-6">Contacto</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-gold text-lg flex-shrink-0 w-5 h-5 flex items-center justify-center"></i>
                <span className="font-body text-sm text-gray-200">
                  Prol. 5 de Mayo, 727. Lomas de Tarango, Álvaro Obregón, CDMX
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-phone-line text-gold text-lg w-5 h-5 flex items-center justify-center"></i>
                <a href="tel:+525614025070" className="font-body text-sm text-gray-200 hover:text-gold transition-colors">
                  56 1402 5070
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-mail-line text-gold text-lg w-5 h-5 flex items-center justify-center"></i>
                <a href="mailto:ventas@kronoscc.com" className="font-body text-sm text-gray-200 hover:text-gold transition-colors">
                  ventas@kronoscc.com
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-base mb-6">Síguenos</h4>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/profile.php?id=61581041445787"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-gold flex items-center justify-center transition-colors"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://www.instagram.com/kronos_ceo_consultores"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-gold flex items-center justify-center transition-colors"
                aria-label="Instagram"
              >
                <i className="ri-instagram-fill text-lg"></i>
              </a>
              <a
                href="https://wa.me/525614025070"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-gold flex items-center justify-center transition-colors"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-fill text-lg"></i>
              </a>
              <a
                href="https://www.linkedin.com/company/kronos-ceo-consultores-sc"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-gold flex items-center justify-center transition-colors"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
            <div className="mt-8">
              <p className="font-body text-xs text-gray-300 mb-2">Horario de atención:</p>
              <p className="font-body text-sm text-gray-200">Lunes a Viernes</p>
              <p className="font-body text-sm text-gray-200">9:00 AM - 6:00 PM</p>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 mt-12 pt-8 text-center">
          <p className="font-body text-sm text-gray-300">
            &copy; {new Date().getFullYear()} Kronos CEO Consultores, S.C. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;